import { createFirebaseAuth } from '@lotushealth/web_kit/firebase';

import { logger } from '../../lib/telemetry/logger.js';

import { firebaseApp } from './app.js';

export const auth = createFirebaseAuth(firebaseApp, {
  persistence: 'session',
  onPersistenceError: (error: unknown) => {
    logger.error(
      'firebase auth persistence failed; using in-memory',
      { source: 'firebase/auth' },
      error
    );
  },
});
